import { render, staticRenderFns } from "./Arrivals.vue?vue&type=template&id=6243ae8e&scoped=true&"
import script from "./Arrivals.vue?vue&type=script&lang=js&"
export * from "./Arrivals.vue?vue&type=script&lang=js&"
import style0 from "./Arrivals.vue?vue&type=style&index=0&id=6243ae8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6243ae8e",
  null
  
)

export default component.exports